import React from 'react';
import PropTypes from 'prop-types';

import styles from './toast.module.scss';
import { Icon } from '@archre2/react-core';
import { mergeClassNames } from 'core/utils';

// React 19 Migration: Using default parameters instead of defaultProps
const ToastController = (props) => {
  const [active, setActive] = React.useState(true);
  // Used to indicate if we can update the state or not in some edge cases
  const mounted = React.useRef(false);

  const {
    duration = 6000,
    onDismiss,
    className = '',
    children,
    type = 'info',
    autoClose = true,
  } = props;
  const showToast = active ? '' : styles.hide;
  const typeClassName = styles[`toast--${type}`] || '';

  React.useEffect(() => {
    mounted.current = true;

    setTimeout(() => {
      if (mounted.current && autoClose) setActive(false);
    }, duration);
  }, [duration, autoClose]);

  React.useEffect(() => {
    return function () {
      mounted.current = false;
    };
  }, []);

  React.useEffect(() => {
    if (!active) setTimeout(onDismiss, 300);
  }, [active, onDismiss]);

  return (
    <div
      className={mergeClassNames(
        styles.toast,
        showToast,
        className,
        styles.toastBase,
        typeClassName
      )}
    >
      <span className={styles.content}>{children}</span>
      <button onClick={() => setActive(false)} className={styles.close}>
        <Icon className={styles.close}>times-circle</Icon>
      </button>
    </div>
  );
};

ToastController.propTypes = {
  className: PropTypes.string,
  onDismiss: PropTypes.func,
  duration: PropTypes.number,
  options: PropTypes.object,
  type: PropTypes.oneOf(['info', 'primary', 'error', 'warning', 'success']),
  autoClose: PropTypes.bool,
};

export default ToastController;
